<template>
    <div
        class="min-w-[250px] md:w-[350px] flex flex-col gap-2 p-4 rounded-lg border border-solid border-grey-40 hover:shadow hover:border-grey-55"
        :class="{ 'border-2 !border-eureka-500 hover:!border-eureka-600': highlight }"
    >
        <div class="h-20 border-b borer-solid border-grey-40 rounded-t-lg relative">
            <h3 class="text-base font-bold mb-1" :class="highlight ? 'text-eureka-600' : 'text-black'">{{ t(`packageDiff.${type}.title`) }}</h3>
            <p class="text-sm text-gray-90">{{ t(`packageDiff.${type}.description`) }}</p>
            <slot name="current" />
        </div>
        <ul class="flex flex-col gap-2 md:h-[180px]">
            <li v-for="(feature, key) in features" :key="type + key" class="flex text-sm text-grey-450 gap-1">
                <PtIcon
                    :icon="SolidTickCircle"
                    class="th-btn-icon text-xl flex-shrink-0"
                    :class="highlight ? 'fill-eureka-500' : 'fill-grey-200'"
                />
                {{ feature }}
            </li>
        </ul>
        <div class="relative">
            <slot name="button" />
            <button @click="handleClick" class="th-btn w-full" v-if="showButton" :class="highlight ? 'th-btn-primary' : 'th-btn-secondary'">
                {{ highlight ? t(`editionInfo.onboarding.buttonText`) : t(`packageDiff.${type}.buttonText`) }}
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { PtIcon } from 'patsnap-biz';
import type { EditionType } from '../../constants';
import SolidTickCircle from '@patsnap-ui/icon/assets/solid/TickCircle.svg';
import { cn, en, jp, tw } from '../../infrastructure/locales';

const { t } = useI18n({
    messages: {
        cn, en, jp, tw,
    },
});
const props = defineProps<{
  type: EditionType,
  features: string[],
  highlight: boolean,
  showButton: boolean,
}>();

const emits = defineEmits<{
    (event: 'choose', isPremium: boolean): void
}>();

function handleClick() {
    emits('choose', !props.highlight);
}
</script>
